/* src/app/pages/tos/tos.page.scss */
ion-content {
  --background: #0d1117;
}
ion-header {
  box-shadow: none;
  border-bottom: 1px solid var(--color-black);
}
h1,
h2,
h3,
h4,
h5 {
  font-size: 20px;
  line-height: 116%;
  letter-spacing: 0.02em;
  vertical-align: middle;
  text-transform: uppercase;
  font-family: AppFontBold;
  color: #fff;
  text-align: center;
}
h4 {
  color: #fff;
  font-size: 18px;
}
@media (max-width: 992px) {
  h4 {
    font-size: 15px;
  }
}
li {
  color: #fff;
  font-family: AppFont;
}
p {
  font-size: 16px;
  line-height: 120%;
  vertical-align: middle;
  text-align: center;
  color: #fff;
}
@media (max-width: 992px) {
  p {
    font-size: 14px;
  }
}
ol {
  counter-reset: item;
  padding: 0;
}
ol > li {
  display: block;
}
ol > li h3:before {
  content: counters(item, ".") ". ";
  counter-increment: item;
  margin-right: 6px;
}
ol > li p {
  display: block;
  margin: 0;
  color: #fff;
}
ol > li ol > li {
  margin: 8px 0;
  display: flex;
  flex-direction: row;
}
ol > li:before {
  content: counters(item, ".") " ";
  counter-increment: item;
  margin: 0 8px 0 0;
}
ion-content > ol {
  padding: 0;
}
ion-content > ol > li:before {
  content: none;
}
ul {
  list-style-type: disc;
  padding-left: 30px;
}
ion-content > ol > li > div {
  padding-left: 30px;
}
p.ion-padding-start {
  padding-left: 30px;
}
.legal__container {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 50rem;
}
.legal__title {
  font-family: AppFontBold;
  font-size: 40px;
  margin-top: 30px;
}
.legal__title.second {
  margin-top: 140px;
}
.legal__subtitle {
  font-size: 0.75rem;
  letter-spacing: 0.05em;
  line-height: 1.2;
  text-transform: uppercase;
  margin-bottom: 30px;
}
h3 {
  font-size: 30px;
  margin-bottom: 30px;
}
p:has(strong) {
  margin-top: 20px;
  margin-bottom: 10px;
}
/*# sourceMappingURL=tos.page.css.map */
